import { combineReducers } from 'redux';
import dataCentreReducer from './dataCentreReducer';
import erpTypeReducer from './erpTypeReducer';
import storeReducer from './storeReducer';
import operatorReducer from './operatorReducer';
import userReducer from './userReducer';
import sync from './sync';
import backupReducer from './backupReducer';
import versionReducer from './versionReducer';
import dataFileReducer from './dataFileReducer';
import configReducer from './configReducer';
import environmentReducer from './environmentReducer';
import gatewayReducer from './gatewayReducer';
import clientCredentialReducer from './clientCredentialReducer';
import appStoreReducer from './appStoreReducer';

const rootReducer = combineReducers({
  environment: environmentReducer,
  config: configReducer,
  version: versionReducer,
  backup: backupReducer,
  sync,
  dataFile: dataFileReducer,
  user: userReducer,
  dataCentre: dataCentreReducer,
  erpType: erpTypeReducer,
  store: storeReducer,
  operator: operatorReducer,
  gateway: gatewayReducer,
  clientCredential: clientCredentialReducer,
  appStore: appStoreReducer,
});

export default rootReducer;
